<template>
	<div class="head-container">
		<div class="head-content">
			<router-link to="/index" class="logo">
				<img src="@/assets/logo.png" alt="楚建通" />
				<div class="logo-text">
					<span class="divider"></span>

					<span>创新服务 共建共赢</span>
				</div>
			</router-link>

			<div class="nav-menu">
				<router-link
					v-for="(item, index) in navMenuList"
					:key="index"
					:to="item.path"
					class="nav-item"
					:class="{ active: isActiveRoute(item.path) }"
				>
					{{ item.name }}
				</router-link>
			</div>

			<div class="contact">
				<div class="user-actions">
					<!-- <router-link to="/messages" class="action-item">
						<svg-icon icon-class="wechatMini" class="icon" />
					</router-link> -->
					<el-popover ref="popover" placement="bottom" width="400" trigger="click" @show="showMessageContent">
						<div class="message-content">
							<div class="section-title">
								<div class="section-title_left">
									<h3>消息通知</h3>
								</div>
								<router-link to="/user/message" class="section-title_more">
									更多
									<i class="el-icon-arrow-right"></i>
								</router-link>
							</div>
							<div v-for="(item, index) in messageList" :key="index" class="message-row" @click="handleToMessage(item)">
								<div class="message-title" :class="{ isNoRead: item.msgConsumeState === 0 }">
									<span>[{{ item.msgTagsName }}]</span>
									{{ item.msgTitle }}
									<span class="time">{{ item.createTime | formatDate }}</span>
								</div>
								<div class="message-text">
									{{ item.msgContent }}
								</div>
							</div>
						</div>
						<div slot="reference" class="action-item" title="消息通知">
							<el-badge v-if="userUnreadMessageCount !== 0" :value="userUnreadMessageCount" class="message-badge">
								<svg-icon icon-class="notice" class="icon" />
							</el-badge>
							<svg-icon v-else icon-class="notice" class="icon" />
						</div>
					</el-popover>

					<el-popover ref="popover" placement="bottom" width="400" trigger="click" @show="showWarrningMessageContent">
						<div class="message-content">
							<div class="section-title">
								<div class="section-title_left">
									<h3>委托预警</h3>
								</div>
								<router-link to="/qualification/maintenance" class="section-title_more">
									更多
									<i class="el-icon-arrow-right"></i>
								</router-link>
							</div>
							<div v-for="(item, index) in warrningMessageList" :key="index" class="message-row" @click="handleToMessage(item)">
								<div class="message-title" :class="{ isNoRead: item.msgConsumeState === 0 }">
									<span>[{{ item.msgTagsName }}]</span>
									{{ item.msgTitle }}
									<span class="time">{{ item.createTime | formatDate }}</span>
								</div>
								<div class="message-text">
									{{ item.msgContent }}
								</div>
							</div>
						</div>
						<div slot="reference" class="action-item" title="委托预警">
							<el-badge v-if="unreadWarning !== 0" :value="unreadWarning" class="message-badge">
								<svg-icon icon-class="warning" class="icon" />
							</el-badge>
							<svg-icon v-else icon-class="warning" class="icon" />
						</div>
					</el-popover>

					<!-- <router-link to="/member-benefits" class="action-item">
						<span>会员权益</span>
					</router-link> -->

					<div v-if="isNormalVip" class="action-item normal-vip-tag">
						<span>普通会员</span>
					</div>

					<div v-if="isVip" class="action-item vip-tag">
						<i></i>
						<span>VIP</span>
					</div>

					<div v-if="isSVip" class="action-item svip-tag">
						<i></i>
						<span>SVIP</span>
					</div>

					<router-link v-if="!token" to="/login" class="action-item">
						<span class="login">登录</span>
					</router-link>

					<div v-if="token" class="user-info" @click.stop="toggleUserMenu">
						<div class="avatar">
							<img src="@/assets/user/user-avator.png" alt="用户头像" />
						</div>

						<span class="nickname">{{ realName }}</span>

						<!-- 下拉菜单 -->
						<div v-show="showUserMenu" v-click-outside="handleCloseUserMenu" class="dropdown-menu">
							<div class="menu-item" @click="handleMenuClick('profile')">
								<svg-icon icon-class="user" />
								<span>个人资料</span>
							</div>
							<div class="menu-item" @click="handleMenuClick('message')">
								<svg-icon icon-class="notice" />
								<span>消息通知</span>
								<span v-show="userUnreadMessageCount !== 0" class="badge">{{ userUnreadMessageCount }}</span>
							</div>
							<div class="menu-item" @click="handleMenuClick('monitor')">
								<svg-icon icon-class="warning" />
								<span>委托预警</span>
								<span v-show="unreadWarning !== 0" class="badge">{{ unreadWarning }}</span>
							</div>
							<div class="menu-item" @click="handleMenuClick('market')">
								<svg-icon icon-class="warning" />
								<span>会员管理</span>
							</div>
							<div class="menu-item" @click="handleMenuClick('rights')">
								<svg-icon icon-class="warning" />
								<span>会员权益</span>
							</div>
							<div class="menu-item" @click="handleMenuClick('service')">
								<svg-icon icon-class="warning" />
								<span>客服服务</span>
							</div>
							<div class="menu-item logout-btn">
								<el-button @click="handleLogout">退出登录</el-button>
							</div>
						</div>
					</div>
				</div>
				<div v-if="!token" class="contact-tel">
					<img src="@/assets/login/tel.png" alt="电话" />
					<span>400-992-5998</span>
				</div>
			</div>
		</div>

		<!-- 购买会员弹窗 -->
		<jr-dialog :visible.sync="payVisible" width="840px" :show-btn="false" @close="handleCancelPay">
			<template slot="title">
				<!-- 自定义弹窗标题 -->
				<h4 class="model-title">
					<span>购买会员</span>
				</h4>
			</template>
			<template slot="content">
				<payment-dialog @payOrderSuccess="handlePayOrderSuccessCallback"></payment-dialog>
			</template>
		</jr-dialog>
	</div>
</template>

<script>
	import JrDialog from '@/components/Dialog'
	import PaymentDialog from '@/views/memberBenefits/paymentDialog.vue'
	import { mapGetters, mapState } from 'vuex'
	import { getCountUserMessage, getUserMessageList, handleSetRead } from '@/api/user/message'
	import defaultSettings from '@/settings'

	// 网站顶部导航
	export default {
		name: 'TopNavHead',
		components: { JrDialog, PaymentDialog },
		props: {},
		data() {
			return {
				// 购买会员弹窗
				payVisible: false,
				// 顶部导航菜单
				navMenuList: [
					{
						name: '首页',
						path: '/index'
					},
					{
						name: '资质宝',
						path: '/qualification/index'
					},
					{
						name: '资质查',
						path: '/qualification-query/index'
					},
					// {
					// 	name: '应用商城',
					// 	path: '/mall'
					// },
					{
						name: '会员权益',
						path: '/member-benefits'
					},
					// {
					// 	name: '政策快讯',
					// 	path: '/policy'
					// },
					{
						name: '用工服务',
						path: '/employment'
					}
				],
				showUserMenu: false,
				messageList: [],
				warrningMessageList: []
			}
		},
		computed: {
			...mapState({
				token: state => state.user.token,
				userUnreadMessageCount: state => state.user.userUnreadMessageCount,
				unreadWarning: state => state.user.unreadWarning
			}),
			...mapGetters(['realName', 'vipLevel', 'isNormalVip', 'isVip', 'isSVip']),
			messagesTagsDict() {
				const dicts = this.$store.state.dictionary?.dictionaries
				return dicts?.messagesTags.filter(f => f.tags === 'home') || []
			}
		},
		watch: {
			messagesTagsDict: {
				immediate: true,
				handler(newVal) {
					console.log('messagesTagsDict changed:', newVal)
					if (newVal && newVal.length && this.token) {
						this.getMessageCount()
						this.initMessageList()
						this.initWarrningMessageList()
						this.getMonitoringAlertsCount()
					}
				}
			}
		},
		created() {},
		mounted() {
			if (this.token) {
				this.$nextTick(() => {
					if (this.messagesTagsDict && this.messagesTagsDict.length) {
						this.getMessageCount()
						this.getMonitoringAlertsCount()
					}
				})
			}
		},
		methods: {
			initMessageList() {
				// TODO: 初始化三条消息列表数据
				const params = {
					msgType: '1',
					msgTagList: this.messagesTagsDict.map(m => m.dictCode).join(','),
					msgConsumeState: '1',
					page: 1,
					size: 3
				}
				getUserMessageList(params).then(response => {
					if (response.code === 200) {
						this.messageList = response.data.records
					}
				})
			},
			initWarrningMessageList() {
				// TODO: 初始化三条委托预警消息列表数据
				const params = {
					msgType: '1',
					msgTagList: 'MSG_WTYJ',
					msgConsumeState: '1',
					page: 1,
					size: 3
				}
				getUserMessageList(params).then(response => {
					if (response.code === 200) {
						this.warrningMessageList = response.data.records
					}
				})
			},
			/**
			 * 获取用户未读消息数量
			 * 通过调用接口获取当前用户的未读消息数量
			 */
			getMessageCount() {
				// 请求参数：msgConsumeState=0表示未读消息
				const params = {
					msgType: '1',
					msgConsumeState: '0',
					msgTagList:
						this.messagesTagsDict && this.messagesTagsDict.length > 0 ? this.messagesTagsDict.map(m => m.dictCode).join(',') : ''
				}
				// 调用API获取未读消息数量
				getCountUserMessage(params).then(response => {
					// 请求成功时更新未读消息数量
					if (response.code === 200) {
						this.$store.dispatch('user/setUnreadMessageCount', response.data)
					}
				})
			},
			/**
			 * 获取委托预警未读数量
			 * 通过调用接口获取当前用户的未读委托预警消息数量
			 */
			getMonitoringAlertsCount() {
				// 请求参数：
				// msgConsumeState=0 表示未读消息
				// msgTags='MSG_WTYJ' 表示委托预警类型的消息
				const params = {
					msgType: '1',
					msgConsumeState: '0',
					msgTags: 'MSG_WTYJ'
				}
				// 调用API获取未读委托预警数量
				getCountUserMessage(params).then(response => {
					// 请求成功时更新未读预警数量
					if (response.code === 200) {
						this.$store.dispatch('user/setUnreadWarning', response.data)
					}
				})
			},

			// 判断当前路由是否激活
			isActiveRoute(path) {
				// 特殊处理首页路由
				if (path === '/index' && this.$route.path === '/') {
					return true
				}

				// 提取当前路由的第一段路径
				const currentMainPath = '/' + this.$route.path.split('/')[1]

				// 提取菜单项的第一段路径
				const menuMainPath = '/' + path.split('/')[1]

				// 比较两者是否相同
				return currentMainPath === menuMainPath
			},

			toggleUserMenu() {
				this.showUserMenu = !this.showUserMenu
			},
			handleCloseUserMenu() {
				this.showUserMenu = false
			},
			handleMenuClick(type) {
				// 处理菜单点击
				this.showUserMenu = false
				// 添加路由导航守卫
				const routePath = {
					profile: '/user/profile',
					message: '/user/message',
					monitor: '/qualification/maintenance',
					market: '/user/market/order',
					rights: '/user/market/my-member-benefits',
					service: '/user/service'
				}[type]

				if (routePath && this.$route.path !== routePath) {
					this.$router.push(routePath).catch(err => {
						if (err.name !== 'NavigationDuplicated') {
							throw err
						}
					})
				}
			},

			//  退出登录
			handleLogout() {
				this.$store.dispatch('user/logout').then(() => {
					location.href = defaultSettings.publicPath + '/index'
				})
			},
			// 订单创建成功回调
			handlePayOrderSuccessCallback() {
				this.payVisible = false
				this.$router.push({
					path: '/user/market/order'
				})
			},
			handleCancelPay() {
				this.payVisible = false
			},
			// 点击不同消息类型做出不同处理
			handleToMessage(item) {
				switch (item.msgTagsName) {
					case '系统通知':
						this.$router.push({
							path: '/user/message'
						})
						break
					case '会员福利':
						this.payVisible = true
						break
					case '委托预警':
						this.$router.push({
							path: '/qualification/maintenance'
						})
						break
				}
			},
			// 是否展示消息列表
			showMessageContent() {
				if (this.userUnreadMessageCount === 0) {
					// 阻止Popover显示
					this.$refs.popover.doClose()
					this.$router.push({
						path: '/user/message'
					})
					return
				}
				const params = {
					consumeType: '1',
					msgIds: this.messageList.map(item => item.id)
				}
				handleSetRead(params).then(response => {
					if (response.code === 200) {
						this.initMessageList()
						this.$store.dispatch('user/setUnreadMessageCount', 0)
					}
				})
			},
			// 是否展示委托预警消息列表
			showWarrningMessageContent() {
				if (this.unreadWarning === 0) {
					// 阻止Popover显示
					this.$refs.popover.doClose()
					this.$router.push({
						path: '/qualification/maintenance'
					})
					return
				}
				const params = {
					consumeType: '1',
					msgIds: this.warrningMessageList.map(item => item.id)
				}
				handleSetRead(params).then(response => {
					if (response.code === 200) {
						this.initWarrningMessageList()
						this.$store.dispatch('user/setUnreadWarning', 0)
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.head-container {
		height: $top-bar-height;
		background: #ffffff;
		border-bottom: solid 1px #d8e7fe;

		.head-content {
			height: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 20px;
			margin: 0 auto;

			.logo {
				flex: 0 0 auto;
				display: flex;
				align-items: center;
				min-width: 280px;
				img {
					width: auto;
					height: 60px;
				}

				.logo-text {
					display: flex;
					align-items: center;
					white-space: nowrap;

					.divider {
						height: 50px;
						border: solid 1px #c0c2c5;
						margin: 0 15px;
					}

					span {
						font-size: 20px;
						color: #213251;
					}
				}
			}

			.contact {
				flex: 0 0 auto;
				min-width: 280px;
				display: flex;
				align-items: center;

				.user-actions {
					display: flex;
					align-items: center;
					flex-wrap: nowrap;
					margin-right: 20px;

					.action-item {
						display: flex;
						align-items: center;
						padding: 0 8px;
						color: #333333;
						text-decoration: none;
						white-space: nowrap;
						cursor: pointer;
						transition: all 0.3s;

						&:hover,
						&:hover .icon {
							color: #1374eb;
						}

						.icon {
							color: #88949f;
							font-size: 25px;
							margin-right: 5px;
						}

						span {
							font-size: 18px;

							&.login {
								color: #1374eb;
							}
						}

						&.svip-tag {
							background: #ffccb8;
							border-radius: 15px;
							color: #f2450a;
							padding: 0 15px 0 25px;
							margin: 0 10px;
							background-image: linear-gradient(90deg, #ffccb8 0%, #ff9e84 100%);
							position: relative;

							i {
								width: 30px;
								height: 30px;
								background-image: url('~@/assets/vip/svip-tag-small.png');
								background-repeat: no-repeat;
								background-size: 100%;
								background-position: 50% 50%;
								position: absolute;
								top: -10px;
								left: -10px;
							}

							span {
								font-size: 16px;
							}
						}

						&.vip-tag {
							background: #ffccb8;
							border-radius: 15px;
							color: #934e25;
							padding: 0 15px 0 25px;
							margin: 0 10px;
							background-image: linear-gradient(90deg, #ffd88e 0%, #faa250 100%);
							position: relative;

							i {
								width: 30px;
								height: 30px;
								background-image: url('~@/assets/vip/vip-tag-small.png');
								background-repeat: no-repeat;
								background-size: 100%;
								background-position: 50% 50%;
								position: absolute;
								top: -10px;
								left: -10px;
							}

							span {
								font-size: 16px;
							}
						}

						&.normal-vip-tag {
							background: #ededed;
							border-radius: 15px;
							color: #333333;
							padding: 0 15px 0 15px;
							margin: 0 10px;

							span {
								font-size: 16px;
								line-height: 26px;
							}
						}
					}

					.message-badge {
						.el-badge__content {
							background-color: #ff1a2e;
							border-radius: 15px;
							width: 20px;
							height: 20px;
							line-height: 20px;
							padding: 0;
							border: none;
						}
					}

					.user-info {
						position: relative;
						display: flex;
						align-items: center;
						cursor: pointer;
						padding: 5px 10px;
						border-radius: 4px;

						&:hover {
							background: #f5f7fa;
						}

						.avatar {
							width: 45px;
							height: 45px;
							border-radius: 50%;
							margin-right: 8px;
							overflow: hidden;
							img {
								width: 100%;
								height: 100%;
								object-fit: cover;
							}
						}

						.nickname {
							max-width: 75px;
							font-size: 18px;
							color: #333;
							margin-right: 5px;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}

						.dropdown-menu {
							position: absolute;
							top: 100%;
							right: 0;
							width: 180px;
							background: #fff;
							box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
							border-radius: 4px;
							border: solid 1px #e4ecef;
							padding: 20px 0;
							z-index: 1000;

							.menu-item {
								display: flex;
								align-items: center;
								padding: 10px 20px;
								color: #333;
								transition: all 0.3s;

								.svg-icon {
									font-size: 16px;
									margin-right: 8px;
									color: #666;
								}

								&:hover {
									background: #f5f7fa;
									color: #1374eb;

									.svg-icon {
										color: #1374eb;
									}
								}

								.badge {
									width: 18px;
									height: 18px;
									line-height: 18px;
									text-align: center;
									margin-left: auto;
									background: #ff4949;
									color: #fff;
									border-radius: 10px;
									font-size: 12px;
								}

								&.logout-btn {
									.el-button {
										width: 100%;
									}
								}
							}

							.divider {
								height: 1px;
								background: #eee;
								margin: 5px 0;
							}
						}
					}
				}

				.contact-tel {
					height: 40px;
					border-radius: 20px;
					border: solid 1px #205eda;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
					transition: all 0.3s;
					padding: 0 5px;

					&:hover {
						background: #f5f9ff;
					}

					img {
						width: 30px;
						height: 30px;
						margin-right: 8px;
					}

					span {
						color: #205eda;
						font-size: 18px;
						font-weight: 500;
					}
				}
			}

			/* 导航栏 */
			.nav-menu {
				flex: 1;
				display: flex;
				align-items: center;
				justify-content: center;
				margin: 0 20px;
				min-width: 600px;

				.nav-item {
					padding: 0 15px;
					position: relative;
					height: 80px;
					line-height: 80px;
					font-size: 18px;
					color: #333;
					text-decoration: none;
					white-space: nowrap;
					transition: all 0.3s;

					& + .nav-item {
						margin-left: 20px;
					}

					&::after {
						content: '';
						position: absolute;
						bottom: 0;
						left: 50%;
						transform: translateX(-50%);
						// right: 10px;
						width: 0;
						height: 4px;
						background: #236fca;
						transition: all 0.3s ease;
					}

					&:hover {
						color: #246fca;
						&::after {
							width: 80%;
						}
					}

					&.active {
						color: #246fca;
						font-weight: 500;

						&::after {
							width: 100%;
						}
					}
				}
			}
		}
	}
	.message-content {
		.message-row {
			padding: 20px 0px;
			border-bottom: 1px dashed #dcdcdc;
			padding-left: 20px;
			cursor: pointer;
			transition: all 0.3s ease; // 添加过渡效果

			&:hover {
				background-color: #f5f7fa; // 鼠标悬停时的背景色
				transform: translateX(5px); // 轻微右移效果
			}
			&:last-child {
				border-bottom: none;
			}
			.message-title {
				font-weight: bold;
				color: #333;
				position: relative;
				span {
					color: #427fd1;
					margin-right: 5px;
					font-weight: normal;
				}
				.time {
					float: right;
					font-size: 14px;
					color: #ababab;
				}
				&::before {
					content: '';
					position: absolute;
					left: -20px;
					top: 50%;
					transform: translateY(-50%);
					width: 8px;
					height: 8px;
					border-radius: 50%;
					background-color: #cccccc;
				}
			}
			.isNoRead {
				&::before {
					background-color: #ff1a2e;
				}
			}
			.message-text {
				color: #8f8f8f;
				margin-top: 10px;
				max-width: 800px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}
		.section-title {
			margin-bottom: 5px;
			.section-title_left {
				h3 {
					font-size: 14px;
				}
				&::before {
					display: none;
				}
			}
			.section-title_more {
				font-size: 12px;
			}
		}
	}

	// 大屏适配
	@media screen and (min-width: 1600px) {
		.head-container .head-content {
			.nav-menu .nav-item {
				padding: 0 20px;
				font-size: 18px;

				& + .nav-item {
					margin-left: 30px;
				}
			}

			.contact .user-actions {
				.action-item {
					padding: 0 12px;

					span {
						font-size: 16px;
					}
				}
			}
		}
	}

	// 小屏适配
	@media screen and (max-width: 1560px) {
		.head-container .head-content {
			.logo {
				min-width: 240px;

				.logo-text span {
					font-size: 16px;
				}
			}

			.nav-menu {
				min-width: 420px;

				.nav-item {
					padding: 0 10px;
					font-size: 16px;

					& + .nav-item {
						margin-left: 15px;
					}
				}
			}

			.contact {
				min-width: 260px;
				// max-width: 375px;

				.user-actions {
					.action-item {
						padding: 0 5px;

						span {
							font-size: 16px;
						}
					}

					.user-info {
						.avatar {
							width: 35px;
							height: 35px;
						}
						.nickname {
							font-size: 16px;
						}
					}
				}
			}
		}
	}
</style>
